import {useEffect} from 'react'
import {useRouteError} from 'react-router'
import {ButtonLegacy} from './elements'
import {Logo} from './svg/Logo'

export function MainErrorBoundary() {
  const error = useRouteError()
  const message = error instanceof Error ? error.message : 'Unknown error'

  useEffect(() => {
    if (error instanceof Error) {
      if (
        error.message.includes('Failed to fetch dynamically imported module')
      ) {
        const url = new URL(window.location.href)
        if (url.searchParams.has('_errorForceReload')) return
        url.searchParams.set('_errorForceReload', 'true')
        window.location.replace(url)
      }
    }
  }, [error])

  return (
    <div className='w-screen h-screen flex justify-center items-center'>
      <div className='text-white flex flex-col items-center space-y-10 max-w-sm px-5'>
        <Logo className='w-32 fill-white/75' />

        <div className='flex flex-col items-center text-wolfSize'>
          <h1 className='text-bearSize mb-2'>Oh no</h1>
          <p className='text-center'>
            We experienced an unhandled error - sorry!
          </p>
          <p className='text-center'>
            Please try to reload the application and try again
          </p>
          <ButtonLegacy
            theme='primary'
            icon='refresh'
            onClick={() => window.location.reload()}
            label='Refresh'
            className='mt-5'
          />
        </div>

        <div className='bg-scarpaFlow p-3 space-y-1'>
          <p>Error message:</p>
          <p>{message}</p>
        </div>
      </div>
    </div>
  )
}
